<template>
  <div
    ref="accordionItem"
    class="app-accordion-item"
    :class="{ 'app-accordion-item-active': visible }"
  >
    <div
      class="app-accordion-trigger"
      :data-testid="testId"
      @click="open"
    >
      <div class="d-flex align-items-center justify-content-between w-full cursor-pointer">
        <div class="app-accordion-trigger-line d-flex align-items-center w-full">
          <span class="string-truncate">
            <slot name="accordion-trigger"></slot>
          </span>
        </div>
        <i class="hi hi-right" />
      </div>
    </div>
    <transition
      name="app-accordion"
      @enter="start"
      @after-enter="end"
      @before-leave="start"
      @after-leave="end"
    >
      <div
        v-show="visible"
        class="app-accordion-content"
      >
        <slot name="accordion-content"></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'AppAccordionItem',
  inject: ['Accordion'],
  props: {
    testId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      index: null,
    };
  },
  computed: {
    visible() {
      return this.index === this.Accordion.active;
    },
  },
  created() {
    this.index = this.Accordion.count++;
  },
  methods: {
    open() {
      if (this.visible) {
        this.Accordion.active = this.index === 0 ? 1 : 0;
      } else {
        this.Accordion.active = this.index;
      }
    },
    start(el) {
      this.Accordion.transition = true;
      el.style.height = el.scrollHeight + 'px';
    },
    end(el) {
      this.Accordion.transition = false;
      el.style.height = '';
    },
  },
};
</script>
